import React from "react";
import {
  createStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  type Theme,
  type WithStyles,
  withStyles,
} from "@material-ui/core";

type FormStepsPRops = {
  activeStep?: number;
  steps: string[];
} & WithStyles<typeof styles>;

function FormSteps({ activeStep, classes, steps, ...rest }: FormStepsPRops) {
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      connector={<StepConnector classes={{ line: classes.connectorLine }} />}
      data-active-step={activeStep}
      data-testid="form-steps"
      {...rest}
    >
      {steps.map((step, index) => (
        <Step data-testid={`step-${index}`} key={step}>
          <StepLabel
            classes={{
              active: classes.labelActive,
              completed: classes.labelActive,
            }}
            StepIconProps={{ classes: { root: classes.stepIconRoot } }}
          >
            {step}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

const styles = (theme: Theme) =>
  createStyles({
    connectorLine: {
      border: "none",
      height: "2px",
      background: "repeating-linear-gradient(90deg,#bdbdbd 0 8px,#0000 0 12px)",
    },
    stepIconRoot: {
      fontSize: "32px",
    },
    labelActive: {
      color: `${theme.palette.primary.main} !important`,
    },
  });

export default withStyles(styles)(FormSteps);
